// @flow

function mockLogin(id: string, pass: string) {
  return {
    status: 200,
    login: true,
  }
}


export const doLogin = (id: string, pass: string): Promise<*> => {
  return Promise.resolve(mockLogin());
};